import { ChangeDetectionStrategy, Component, Injector, OnInit } from "@angular/core";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";

@Component({
    selector: "adapt-common-fonts-and-colors-page",
    templateUrl: "./common-fonts-and-colors-page.component.html",
    styleUrls: ["./common-fonts-and-colors-page.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class CommonFontsAndColorsPageComponent extends BaseRoutedComponent implements OnInit {
    constructor(
        injector: Injector,
    ) {
        super(injector);
    }

    public ngOnInit() {
        this.notifyActivated();
    }
}
